import { useParams } from 'react-router-dom';

import { AppUpdateUserPage } from '~/components/pages/AppUpdateUserPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppUpdateUserRoute: React.FC = () => {
  const { appId, userId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  if (!userId) {
    return <Navigate to={`/apps/${appId}/settings/users`} />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUpdateUserPage appId={appId} userId={userId} />
    </DashboardTemplate>
  );
};
